export const LabsFeaturesConfig = [
    // Main title
    { span: 24, height: "32px", classes: "marginBottom-32" },

    // Feature sections (3 sections)
    { span: 24, height: "24px", classes: "marginBottom-16" },
    { span: 24, height: "60px", classes: "marginBottom-32" },

    { span: 24, height: "24px", classes: "marginBottom-16" },
    { span: 24, height: "60px", classes: "marginBottom-32" },

    { span: 24, height: "24px", classes: "marginBottom-16" },
    { span: 24, height: "60px", classes: "marginBottom-32" },
]
